import { createSlice, PayloadAction } from "@reduxjs/toolkit"
import { TPayment } from "swiipe.portal.shared"

export interface IShopifyStoreAddition {
    shopify: IShopifySliceState
}

export interface IShopifyAppUrls {
    appType: string
    paymentType?: TPayment
    settingsUrl: string
    handle: string
}

interface IShopifySliceState {
    appUrls: {
        [swMerchantId: string]: {
            [webshopId: string]: IShopifyAppUrls[]
        }
    }
}

const initialState: IShopifySliceState = { appUrls: {} }

export const shopifySlice = createSlice({
    name: "shopify",
    initialState,
    reducers: {
        setAppUrls: (
            state,
            action: PayloadAction<{
                swMerchantId: string
                appUrls: {
                    [webshopId: string]: IShopifyAppUrls[]
                }
            }>
        ) => {
            state.appUrls[action.payload.swMerchantId] = action.payload.appUrls
        },
    },
})

export const shopifyActions = shopifySlice.actions
export const shopifySelectors = {
    appUrls: (state: IShopifyStoreAddition, swMerchantId: string) => state.shopify.appUrls[swMerchantId],
}
